import $ from 'jquery';

// Initialize estimate folder form
export function initEstimateFolderForm() {
  $('#estimate-folder-form form').off('submit.estimate-folder');
  $('#estimate-folder-form form').on('submit.estimate-folder', function() {
    $('#create_folder_button').prop('disabled', true);
    $('#create_folder_button').val('Please wait... '); 
  });
}

// Initialize todo form with work context
export function initTodoForm() {
  const $todos = $('#todos');
  const workId = $todos.data('work-id');
  
  if (workId !== undefined) {
    console.log('>>>>>> work_id is: ' + workId);
    $('.work_id').val(workId);
    $('#on_work_form').val(true);
  }
  
  if ($todos.data('dashboard-view') === true) {
    $('#on_dashboard').val(true);
  }
  
  const myTasks = $todos.data('my-tasks');
  $('#my_tasks').val(myTasks);
}

// Expose to global scope for Rails views
window.initEstimateFolderForm = initEstimateFolderForm;
window.initTodoForm = initTodoForm;

// Auto-initialize on turbo:load
$(document).on('turbo:load', function() {
  // Initialize estimate folder form if present
  if ($('#estimate-folder-form form').length > 0) {
    initEstimateFolderForm();
  }
  
  // Initialize todo form if present
  if ($('#todos').length > 0 && $('.todo-form').length > 0) {
    initTodoForm();
  }
});
